import * as yup from 'yup';

import { ObjectTypeBase } from '../../baseTypes/ObjectTypeBase';
import { SortByEnum } from '../../blocks/Sort';
import { PropertiesInterface } from '../Property';
import { TypeContextEnum } from '../TypeContextEnum';
import { Types } from '../Types';
import { TYPE_GROUP_LANE } from '../constants';
import { createShapeFromProperties } from '../createShapeFromProperties';
import { BlockSortDirection } from 'constants-content';

const properties: PropertiesInterface = {
  sortBy: {
    type: 'String',
    validators: [
      {
        name: 'In',
        value: [SortByEnum.StartDate, SortByEnum.EndDate],
      },
    ],
  },
  sortDirection: {
    type: 'String',
    validators: [
      {
        name: 'In',
        value: Object.values(BlockSortDirection),
      },
    ],
  },
};

export class SortType extends ObjectTypeBase {
  group = TYPE_GROUP_LANE;

  name = 'Sort';

  friendlyName = 'Sort Order';

  contexts = [TypeContextEnum.Block, TypeContextEnum.Content];

  superUserOnly = false;
  properties = properties;

  get example() {
    return {
      sortBy: SortByEnum.EndDate,
      sortDirection: BlockSortDirection.Asc,
    };
  }

  get default(): any {
    return {
      sortBy: SortByEnum.EndDate,
      sortDirection: BlockSortDirection.Asc,
    };
  }

  buildSchema() {
    return yup.object().shape(createShapeFromProperties(properties));
  }
}

const sortTypeDefinition = new SortType();

Types.addBaseType(sortTypeDefinition);
export { sortTypeDefinition };
